import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router';
import StackedColumnChart from '../Charts/BarCharts/StackedBarChart';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 280,
    borderRadius: '20px',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)',
  },
  media: {
    height: 280,
    backgroundSize: 'contain',
  },
}));

export default function DashboardCard(props) {
  const {
    cardMedia,
    cardDetails,
    cardTitle,
    textColor,
    backgroundColor,
    path,
    additionalDetails,
    hAxisTitle,
  } = props;
  const [count, setCount] = useState(0);
  const classes = useStyles();
  const history = useHistory();

  React.useEffect(() => {
    if (!cardMedia) {
      setCount(cardDetails);
    }
  }, [cardMedia, cardDetails]);

  const renderAdditionalDetails = () => {
    switch (cardTitle) {
      case 'Last 4 Months Leads Count':
        return (
          <StackedColumnChart
            rawChartData={additionalDetails}
            stackColors={['#15607a', '#09bb9f', '#39f3bb']}
            hAxisTitle={hAxisTitle}
          ></StackedColumnChart>
        );
      case 'QR Code App Leads Count':
        return (
          <table style={{ marginTop: '2px' }}>
            <tbody>
              {Object.entries(additionalDetails).map(([key, value]) => (
                <tr>
                  <td
                    style={{
                      width: '100px',
                      fontWeight: 'bold',
                      fontSize: '18px',
                    }}
                  >
                    {key}
                  </td>
                  <td style={{ fontWeight: 'bold' }}>:</td>
                  <td
                    style={{
                      fontWeight: 'bold',
                      fontSize: '18px',
                      paddingLeft: '18px',
                    }}
                  >
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      default:
        return null;
    }
  };
  return (
    <Card
      style={{ backgroundColor: backgroundColor || '#a6e0de' }}
      className={classes.root}
      elevation={0}
      square
    >
      <CardActionArea onClick={() => history.push(path)}>
        {cardMedia ? (
          <CardMedia className={classes.media} image={cardMedia} />
        ) : (
          <CardContent>
            <Box
              color={`common.${textColor}`}
              height="300px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              alignContent="center"
            >
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                color="inherit"
              >
                {cardTitle}
              </Typography>
              {renderAdditionalDetails()}
              {count && <Typography variant="h3">{count}</Typography>}
            </Box>
          </CardContent>
        )}
      </CardActionArea>
    </Card>
  );
}

DashboardCard.propTypes = {
  cardMedia: PropTypes.node,
  cardTitle: PropTypes.string,
  cardDetails: PropTypes.any,
  path: PropTypes.string,
  textColor: PropTypes.oneOf(['black', 'white']),
  backgroundColor: PropTypes.oneOf(['#a6e0de', 'white']),
  additionalDetails: PropTypes.any,
};

DashboardCard.defaultProps = {
  textColor: 'black',
};
